import { ValidatorProvider } from '@dofleini/validator';
import { partner } from '@mep/pae-commons';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import CardTypeSelect from '@/components/CardTypeSelect';
import { useResponsive } from '@/contexts/ResponsiveContext';

const { CIVIL_STATUS_ENUM } = partner;

const CivilStatusSelect = ({ value, onChange }) => {
  const { isMobile } = useResponsive();
  
  return (
    <CardTypeSelect
      isButton={false}
      fullWidth={false}
      isRow={!isMobile}
      value={value}
      onChange={onChange}
      options={CIVIL_STATUS_ENUM.map((e) => ({
        label: `civilStatus.${e}`,
        help: `civilStatus.${e}_HELP`,
        value: e
      }))}/>
  );
};

CivilStatusSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

CivilStatusSelect.defaultProps = {};

export default memo(CivilStatusSelect);

export const renderCivilStatusSelect = ({ formItemProps, field, form }) => {
  const rules = field?.required && [{ required: true, message: ValidatorProvider.t('validateMessages.required') }];
  
  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <CivilStatusSelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
